'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M20.547 20.343V21H5.406v-.657h15.141Zm-7.964-6.555v5.898h-.657v-5.898h.657Zm5.834-5.799v11.697h-.657V7.989h.657Zm-.329-4.99v.658H6.748V15.28h-.657V3.329c0-.182.147-.33.329-.33h11.669ZM5.022 12.612a.22.22 0 0 1 .155.374L4.063 14.1a.22.22 0 0 1-.31 0l-1.114-1.114a.22.22 0 0 1 .155-.375h2.228Zm-.96-2.399 1.115 1.114a.22.22 0 0 1-.155.374H2.794a.22.22 0 0 1-.155-.374l1.114-1.114a.22.22 0 0 1 .31 0Zm8.521-6.005v5.24h-.657v-5.24h.657Z",
    fill: "#3F3E4B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19.354 3.423h1.786c.195 0 .293.235.155.373L4.16 20.931a.217.217 0 0 1-.154.064H2.219a.219.219 0 0 1-.155-.373L19.199 3.487a.22.22 0 0 1 .155-.064",
    fill: "currentColor"
  })));
});
var FwSet0ElevatorNo = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0ElevatorNo = FwSet0ElevatorNo;